/**
 * HLS manifests tag subtitle renditions with ISO 639-2 codes ('eng', 'spa',
 * 'ger'…) while the rest of the app speaks ISO 639-1 ('en', 'es', 'de').
 * Normalize to 639-1 so preference matching and display grouping line up.
 */
const ISO_639_2_TO_1: Record<string, string> = {
  eng: 'en',
  spa: 'es',
  ger: 'de',
  deu: 'de',
  fre: 'fr',
  fra: 'fr',
  ita: 'it',
  por: 'pt',
  rum: 'ro',
  ron: 'ro',
  gre: 'el',
  ell: 'el',
  dut: 'nl',
  nld: 'nl',
  pol: 'pl',
  swe: 'sv',
  tur: 'tr',
  rus: 'ru',
  ara: 'ar',
  heb: 'he',
  hun: 'hu',
  cze: 'cs',
  ces: 'cs',
  fin: 'fi',
  dan: 'da',
  nor: 'no',
  jpn: 'ja',
  kor: 'ko',
  chi: 'zh',
  zho: 'zh',
};

export function normalizeSubtitleLang(code: string | null | undefined): string {
  const lowered = (code ?? '').trim().toLowerCase();
  if (!lowered) return '';
  // Forced-narrative tags like "forced-ita" — keep the base language.
  const base = lowered.split(/[-_]/).find((part) => part.length === 2 || ISO_639_2_TO_1[part]) ?? lowered;
  if (ISO_639_2_TO_1[base]) return ISO_639_2_TO_1[base];
  return base.slice(0, 2);
}
